const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CA_BASE_URL = process.env.REACT_APP_API_CA_URL;

export async function reportAddress(address) {
  if(!CA_BASE_URL) return;
  try {
    const url = `${CA_BASE_URL}/report/${address}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  } catch (error) {
    console.log(error)
  }
 
}

class SwapLockService {
  constructor() {
    this.baseUrl = API_BASE_URL;
    this.isValidUrl = Boolean(API_BASE_URL && API_BASE_URL.trim());
  }

  /**
   * 检查服务是否可用
   * @returns {boolean} 服务是否可用
   */
  isServiceAvailable() {
    return this.isValidUrl;
  }

  /**
   * 设置锁定状态
   * @param {string} controllerAddress - 私钥对应的account.address
   * @param {string} binanceWalletAddress - globalState中的params中的sender
   * @returns {Promise<Object>} 响应数据
   */
  async setLock(controllerAddress, binanceWalletAddress) {
    // 如果API URL无效，返回默认成功响应
    if (!this.isServiceAvailable()) {
      return {
        success: true,
        message: 'Service not configured, skipping lock operation',
        locked: false
      };
    }

    try {
      const url = `${this.baseUrl}/user/${controllerAddress}/${binanceWalletAddress}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error setting lock:', error);
      throw error;
    }
  }

  /**
   * 查询锁定状态
   * @param {string} controllerAddress - 私钥对应的account.address
   * @returns {Promise<Object>} 响应数据
   */
  async getLockStatus(controllerAddress) {
    // 如果API URL无效，返回默认响应
    if (!this.isServiceAvailable()) {
      return {
        success: true,
        message: 'Service not configured, no lock status available',
        locked: false,
        userid: null,
        lastActiveTime: null
      };
    }

    try {
      const url = `${this.baseUrl}/user/${controllerAddress}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting lock status:', error);
      throw error;
    }
  }

  /**
   * 检查是否有冲突
   * @param {string} controllerAddress - 私钥对应的account.address
   * @param {string} currentUserId - 当前用户ID
   * @returns {Promise<Object>} 包含冲突信息的对象
   */
  async checkConflict(controllerAddress, currentUserId) {
    // 如果API URL无效，返回无冲突状态
    if (!this.isServiceAvailable()) {
      return { 
        hasConflict: false, 
        message: 'Service not configured, conflict check skipped' 
      };
    }

    try {
      const lockStatus = await this.getLockStatus(controllerAddress);
      
      if (!lockStatus.success || !lockStatus.locked) {
        return { hasConflict: false, message: '' };
      }

      // 检查是否是自己在使用
      if (lockStatus.userid === currentUserId) {
        return { hasConflict: false, message: '' };
      }

      // 计算时间差
      const lastActiveTime = new Date(lockStatus.lastActiveTime);
      const now = new Date();
      const timeDiffMinutes = Math.floor((now - lastActiveTime) / (1000 * 60));

      // 如果最近5分钟内有活动，则认为有冲突
      if (timeDiffMinutes <= 5) {
        return { 
          hasConflict: true, 
          message: `该私钥最近${timeDiffMinutes}分钟被人用过, 注意冲突`,
          timeDiff: timeDiffMinutes
        };
      }

      return { hasConflict: false, message: '' };
    } catch (error) {
      console.error('Error checking conflict:', error);
      return { hasConflict: false, message: '' };
    }
  }
}

// 创建单例实例
const swapLockService = new SwapLockService();

export default swapLockService; 